import AntdMessage from 'antd/lib/message';

const message = {
    ...AntdMessage,
}
export default message;



// WEBPACK FOOTER //
// ./src/components/message/index.tsx